import { AuthContext } from "context/auth/AuthContext";
import { useContext } from "react";

export function useNullableAuthContext() {
  const context = useContext(AuthContext);
  
  return context;
}